
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmBadgeOutline as ObiAlarmBadgeOutlineElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-badge-outline.js';
 
 
 

 
 export const ObiAlarmBadgeOutline = createComponent({
   react: React,
   tagName: 'obi-alarm-badge-outline',
   elementClass: ObiAlarmBadgeOutlineElement,
   events: {
     
   }
  });
 
 